import { render, staticRenderFns } from "./SelecaoUnidades.vue?vue&type=template&id=25ef0b22&"
import script from "./SelecaoUnidades.vue?vue&type=script&lang=js&"
export * from "./SelecaoUnidades.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports